import React from 'react';

import { Avatar, Badge, Box, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { useTheme } from '@emotion/react';

const ProfileResquestListItem = ({ currentTab, tabValue, setCurrentTab, primaryText, icon, Notifications }) => {
  const theme = useTheme();

  return (
    <ListItemButton
      sx={{
        width: '9rem',
        height: '9rem',
        backgroundColor:
          currentTab === tabValue ? `${theme.palette.secondary.main}!important` : `${theme.palette.grey[100]}80`,
      }}
      selected={currentTab === tabValue}
      onClick={() => setCurrentTab(tabValue)}>
      <Box alignItems={'center'} display={'flex'} flexDirection={'column'}>
        <Badge badgeContent={Notifications} color="error">
          <ListItemAvatar sx={{ minWidth: '1rem' }}>
            <Avatar sx={{ backgroundColor: currentTab === tabValue ? theme.palette.grey[800] : '' }}>{icon}</Avatar>
          </ListItemAvatar>
        </Badge>

        <ListItemText
          sx={{
            color: currentTab === tabValue ? theme.palette.grey[800] : '',
            textAlign: 'center',
          }}
          primary={primaryText}
          primaryTypographyProps={{ fontSize: '0.9rem' }}
        />
      </Box>
    </ListItemButton>
  );
};

export default ProfileResquestListItem;
